export function escapeHtml(s) {
    return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// Indicateur des jours et des heures

export function formatSmartDate(dateString) {
    const msgDate = new Date(dateString);
    const today = new Date();

    const isToday = msgDate.getDate() === today.getDate() &&
                    msgDate.getMonth() === today.getMonth() &&
                    msgDate.getFullYear() === today.getFullYear();

    const optionsHeure = { hour: '2-digit', minute: '2-digit' };
    
    if (isToday) {
        return msgDate.toLocaleTimeString('fr-FR', optionsHeure);
    } else {
        const jourMois = msgDate.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
        const heure = msgDate.toLocaleTimeString('fr-FR', optionsHeure);
        return `${jourMois} ${heure}`;
    }
}

export function formatTime(dateIso) {
    const d = dateIso ? new Date(dateIso) : new Date();
    return d.toLocaleTimeString('fr-FR', { 
        hour: '2-digit', 
        minute: '2-digit',
        timeZone: 'Europe/Paris' 
    });
}

// --- DICTIONNAIRE MAGIQUE DES EMOJIS ---
const raccourcisEmojis = {
    '<3':  '❤️',
    ':D':  '😃',
    ":'D": '😂',
    ':)':  '🙂',
    'O:)': '😇',
    ':(': '🙁',
    ":'(": '😢',
    ':*':  '😘',
    'T.T': '😭',
    ';)':  '😉',
    ':p':  '😛',
    ':P':  '😛',
    'xD':  '😆',
    'XD':  '😆',
    '^^':  '😊',
    'o/':  '👋'
};

export function convertirRaccourcisEnEmojis(texte) {
    let nouveauTexte = texte;
    for (const [raccourci, emoji] of Object.entries(raccourcisEmojis)) {
        const raccourciEchappe = raccourci.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // (?<!\w) et (?!\w) : l'émoticône ne doit pas être collée à une lettre/chiffre
        const regex = new RegExp(`(?<!\\w)${raccourciEchappe}(?!\\w)`, 'g');
        nouveauTexte = nouveauTexte.replace(regex, emoji);
    }
    return nouveauTexte;
}